<template>
  <div v-cloak>
    <div class="vx-card">
      <loading v-if="showLoading"></loading>
      <div class="vx-card__body card-body">
        <div class="vx-row vx-col w-full mb-2 text-left">
          <vs-button
            @click="downloadFile()"
            v-has-permission="permission314"
            class="bg_m_blue ml-4 mr-4"
          >
            {{ $t("DownloadExcelFile") }}
          </vs-button>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              v-has-permission="permission220"
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Name'), sort: 'Name' },
                { title: $t('WarrantyName'), sort: 'warrantyName' },
                { title: $t('ItemCode'), sort: 'ItemCode' },
                { title: $t('ModelNumber'), sort: 'ModelNumber' },
                { title: $t('ColorName'), sort: 'ColorName' }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 40%">
                  {{ row.name }}
                </td>
                <td style="width: 15%">
                  {{ row.warrantyName }}
                </td>
                <td style="width: 15%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 15%">
                  {{ row.modelNumber }}
                </td>
                <td style="width: 12%">
                  {{ row.colorName }}
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "saleManagement_Products_Index",
  components: {
    DataGrid,
    Loading
  },
  data() {
    return {
      permission314: "GetAllSpecificProductsExcel",
      permission220: "GetAllWithFilteredRole",
      gridDataSource: {
        type: "app",
        service: "Sales/api/ProductQuery/filtered-by-role"
      },
      gridSearchData: {
        keyword: ""
      },
      showLoading: false
    };
  },
  methods: {
    ...mapActions({
      exportProductQuery: "excel/exportProductQuery"
    }),
    async downloadFile() {
      this.showLoading = true;
      await this.exportProductQuery();
      this.showLoading = false;
    }
  }
};
</script>
